module.exports = __webpack_public_path__ + "static/media/branchName.80e9d255.build-env";